// export const FETCH_TASKS = 'FETCH_TASKS';
// export const FETCHING_TASKS = 'FETCHING_TASKS';
// export const FETCH_TASKS_SUCCESS = 'FETCH_TASKS_SUCCESS';
// export const FETCH_TASKS_FAILED = 'FETCH_TASKS_FAILED';

export const FETCH_TASK = 'FETCH_TASK';
export const FETCHING_TASK = 'FETCHING_TASK';
export const FETCH_TASK_SUCCESS = 'FETCH_TASK_SUCCESS';
export const FETCH_TASK_FAILED = 'FETCH_TASK_FAILED';

export const UPLOAD_TASKS = 'UPLOAD_TASKS';
export const UPLOADING_TASKS = 'UPLOADING_TASKS';
export const UPLOAD_TASKS_SUCCESS = 'UPLOAD_TASKS_SUCCESS';
export const UPLOAD_TASKS_FAILED = 'UPLOAD_TASKS_FAILED';
export const ASSIGN_RESOURCES_TO_TASKS = 'ASSIGN_RESOURCES_TO_TASKS';
export const SELECTED_TASKS_AVAILABLE = 'SELECTED_TASKS_AVAILABLE';

// export function fetchTasks(jobId) {
//   return {
//     type: FETCH_TASKS,
//     jobId,
//   };
// }

export function selectTasksSuccess(selectedTasks) {
  return {
    type: SELECTED_TASKS_AVAILABLE,
    selectedTasks,
  };
}

// export function fetchingTasks(jobId) {
//   return {
//     type: FETCHING_TASKS,
//     jobId,
//   };
// }
//
// export function fetchTasksSuccess(jobId, tasks) {
//   return {
//     type: FETCH_TASKS_SUCCESS,
//     jobId,
//     tasks,
//   };
// }

export function assignResourcesToTasks(tasks, stages) {
  return {
    type: ASSIGN_RESOURCES_TO_TASKS,
    stages,
    tasks,
  };
}

// export function fetchTasksFailed(jobId, err) {
//   return {
//     type: FETCH_TASKS_FAILED,
//     jobId,
//     message: err.message,
//   };
// }

export function fetchTask(jobId) {
  return {
    type: FETCH_TASK,
    jobId,
  };
}

export function fetchingTask(jobId) {
  return {
    type: FETCHING_TASK,
    jobId,
  };
}

export function fetchTaskSuccess(job) {
  return {
    type: FETCH_TASK_SUCCESS,
    job,
  };
}

export function fetchTaskFailed(jobId, err) {
  return {
    type: FETCH_TASK_FAILED,
    jobId,
    message: err.message,
  };
}

export function uploadTasks(job, tasks, taskProfile) {
  return {
    type: UPLOAD_TASKS,
    job,
    tasks,
    taskProfile,
  };
}

export function uploadingTasks(job, tasks) {
  return {
    type: UPLOADING_TASKS,
    job,
    tasks,
  };
}

export function uploadTasksSuccess(job, tasks) {
  return {
    type: UPLOAD_TASKS_SUCCESS,
    job,
    tasks,
  };
}

export function uploadTasksFailed(job, err) {
  return {
    type: UPLOAD_TASKS_FAILED,
    job,
    message: err.message,
  };
}



// WEBPACK FOOTER //
// ./src/actions/tasks.js